import { useAuthContext } from '@aibees/shared/auth';
import { useIdentifyPostHogUserInfo } from '@aibees/shared/auth/hooks/use-identify-posthog-user-info';

export const PostHogIdentify = () => {
  const { user, token } = useAuthContext();

  useIdentifyPostHogUserInfo(user, token);

  return null;
};

PostHogIdentify.displayName = 'PostHogIdentify';
